import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { setUnauthorizedHandler } from "@/api/client";
import { getMe } from "@/api/auth";
import { useAuthStore } from "@/stores/auth.store";

export function AuthBootstrap() {
  const navigate = useNavigate();
  const accessToken = useAuthStore((s) => s.accessToken);
  const user = useAuthStore((s) => s.user);
  const setUser = useAuthStore((s) => s.setUser);
  const logout = useAuthStore((s) => s.logout);
  const fetchedFor = useRef<string | null>(null);

  useEffect(() => {
    setUnauthorizedHandler(() => {
      logout();
      navigate("/login", { replace: true });
    });
  }, [logout, navigate]);

  useEffect(() => {
    if (!accessToken) {
      fetchedFor.current = null;
      return;
    }
    if (user) return;
    if (fetchedFor.current === accessToken) return;
    fetchedFor.current = accessToken;

    getMe()
      .then((me) => setUser(me))
      .catch(() => {
        logout();
        navigate("/login", { replace: true });
      });
  }, [accessToken, user, setUser, logout, navigate]);

  return null;
}
